<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Eliminar Cuenta"></app-title-three>
  </div>

  <form [formGroup]="deleteAccountForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col size="12" class="ion-text-center">
          <ion-label position="floating">¿Estás seguro que deseas eliminar tu cuenta? </ion-label>
        </ion-col>
        <ion-col size="12">
          <ion-label>
            Al eliminar tu cuenta no podrás ingresar nuevamente a la aplicación a menos que te registres nuevamente. El
            proceso de eliminación de cuenta podrá demorar hasta 30 días, y el usuario recibirá una notificación a su
            dirección de correo registrada una vez se complete el mismo.</ion-label
          >
        </ion-col>
        <ion-col size="12" class="ion-text-center">
          <ion-label>Si estás seguro por favor introduce la siguiente información: </ion-label>
        </ion-col>
        <ion-col size="12" class="ion-text-justify">
          <ion-item>
            <ion-label position="floating">Contraseña actual</ion-label>
            <ion-input mode="md" formControlName="password" maxlength="15" id="password" [type]="typeInput">
            </ion-input>
            <ion-icon slot="end" [name]="eyeImage" class="icon-password" (click)="changeImage()" mode="md"></ion-icon>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.password.errors != null">
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">La contraseña es requerida.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 3 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 50 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese una contraseña valida</ion-text>
            </div>
          </div>
        </ion-col>
        <ion-col size="12" class="ion-text-justify">
          <ion-item>
            <ion-label position="floating">Motivo</ion-label>
            <ion-input mode="md" formControlName="reason" maxlength="30" id="reason"> </ion-input>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.reason.errors != null">
            <div
              *ngIf="
                (errorControl.reason.touched || errorControl.reason.dirty) &&
                errorControl.reason.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El motivo es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.reason.touched || errorControl.reason.dirty) &&
                errorControl.reason.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 5 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.reason.touched || errorControl.reason.dirty) &&
                errorControl.reason.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 30 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.reason.touched || errorControl.reason.dirty) &&
                errorControl.reason.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese un motivo valida</ion-text>
            </div>
          </div>
        </ion-col>
        <ion-col size="12" class="ion-text-justify">
          <ion-item>
            <ion-label position="floating">Mensaje</ion-label>
            <ion-textarea mode="md" formControlName="message" id="message"></ion-textarea>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.message.errors != null">
            <div
              *ngIf="
                (errorControl.message.touched || errorControl.message.dirty) &&
                errorControl.message.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El mensaje es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.message.touched || errorControl.message.dirty) &&
                errorControl.message.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 9 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.message.touched || errorControl.message.dirty) &&
                errorControl.message.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 70 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.message.touched || errorControl.message.dirty) &&
                errorControl.message.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese un mensaje valido</ion-text>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

  <ion-grid class="mt-20">
    <ion-row>
      <ion-col class="ion-text-center">
        <button shape="round" type="submit" id="btn-create" class="btn-primary" id="deleteAccount" (click)="deleteAccount()">
          Eliminar cuenta
        </button>
      </ion-col>

      <ion-col size="12" class="center">
        <button id="closeModal" (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
